export default __webpack_public_path__ + "static/media/2.8d15867a.png";